<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" style="background-color: #dbd5d5;">
    <div class="container">
      <a class="navbar-brand" href="/">Book Store Admin</a>
      <!-- <a class="navbar-brand" href="/">
          <img src="./assets/book-store-logo.jpg" class="logo" alt="">
        </a> -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/orders"
              >My Orders</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/profile"
              >Profiile</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/books"
              >Books</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <a class="nav-link" href="#" @click.prevent="logout">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderComponent",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    cartItemCount() {
      return this.$store.getters.cartItemCount;
    },
    wishlistItemCount() {
      return this.$store.getters.wishlistItemCount;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      window.location.reload();
    },
  },
};
</script>

<style scopped>
.wishlist-count {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  font-size: 10px;
  top: 0;
  left: 30px;
}

@media (min-width: 992px) {
  .wishlist-count {
    top: 0;
    left: 100;
  }
}
</style>
